import React, { useEffect, useState } from "react";

function CharacterCash({ character, editMode, handleSaveCharacter }) {
  const [cash, setCash] = useState({ ...character.cash });
  const [addIndex, setAddIndex] = useState(1);

  useEffect(() => {
    if (!editMode) {
      setCash({ ...character.cash });
    }
  }, [editMode, character]);

  const handleUpdateCash = (value) => {
    setCash({ ...cash, cash: value });
  };

  const handleAddProperty = () => {
    const updatedCash = { ...cash };
    updatedCash.properties.push(`Nuova proprietà ${addIndex}`);
    setAddIndex(addIndex + 1);
    setCash(updatedCash);
  };

  const handleChangeProperty = (index, value) => {
    const updatedCash = { ...cash };
    updatedCash.properties[index] = value;
    setCash(updatedCash);
  };

  const handleDeleteProperty = (index) => {
    if (window.confirm("Sei sicuro di voler cancellare questa proprietà?")) {
      const updatedCash = { ...cash };
      updatedCash.properties.splice(index, 1);
      setCash(updatedCash);
    }
  };

  return (
    <div className="character-sheetpage_cash">
      <div>
        <b>Livello di spesa:</b> {cash.spendinglevel}
      </div>
      {editMode ? (
        <div>
          <b>Cash:</b>
          <input
            type="text"
            value={cash.cash}
            onChange={(e) => handleUpdateCash(e.target.value)}
          />
        </div>
      ) : (
        <div>
          <b>Cash:</b> {cash.cash}
        </div>
      )}
      <div>
        <b>Proprietà:</b>
        <div className="character-sheetpage_cash_properties">
          {cash.properties.map((item, index) => {
            if (editMode) {
              return (
                <div key={index} className="property-row">
                  <input
                    type="text"
                    value={item}
                    onChange={(e) =>
                      handleChangeProperty(index, e.target.value)
                    }
                  />
                  <button
                    onClick={() => handleDeleteProperty(index)}
                    title="Elimina proprietà"
                    className="property-delete-btn"
                  >
                    ✕
                  </button>
                </div>
              );
            } else {
              return (
                <div key={index} className="property-item">
                  {item}
                </div>
              );
            }
          })}
        </div>
      </div>
      {editMode && (
        <>
          <button
            onClick={() =>
              handleSaveCharacter({
                ...character,
                cash: {
                  ...character.cash,
                  cash: cash.cash,
                  properties: cash.properties,
                },
              })
            }
          >
            Salva
          </button>
          <button onClick={() => handleAddProperty()}>
            Aggiungi proprietà
          </button>
        </>
      )}
    </div>
  );
}

export default CharacterCash;
